/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import BaseEditorComponent from 'cio/components/condition-list/edit/base';
import serializeFilter from 'cio/utils/conditions/serialize/action';
import { forEachSegmentable } from 'cio/utils/action-info';
import { elementContainsTarget } from 'cio/utils/dom';
import { isEventTargetInWormhole } from 'cio/utils/wormhole';
import isDestroyed from 'cio/utils/is-destroyed';

const ACTION_TYPES = [{ value: 'email', label: 'Email', icon: 'email' }];

export default class Message extends BaseEditorComponent {
  @service environment;

  // external API
  variation = null;
  subLayout = null;
  disabled = false;

  allowAllVariationsSelection = null;
  allowMessageVariationSelection = null;
  allowMessageWildcardSelection = null;
  allowInParentWildcardSelection = null;
  condition = null;
  allowBlankName = true;
  onApply() {}

  // internal API
  _clickStartedWithin = false;

  init() {
    super.init(...arguments);
    this._onMouseDown = this._onMouseDown.bind(this);
  }

  didInsertElement() {
    super.didInsertElement(...arguments);
    this._addHandlers();
  }

  willDestroyElement() {
    super.willDestroyElement(...arguments);
    this._removeHandlers();
  }

  _addHandlers() {
    this.element.addEventListener('mousedown', this._onMouseDown);
  }

  _removeHandlers() {
    this.element.removeEventListener('mousedown', this._onMouseDown);
  }

  _onMouseDown() {
    if (!isDestroyed(this)) {
      this.set('_clickStartedWithin', true);
    }
  }

  onOutsideClick(event) {
    // When opening fly-power-select, it animates the menu list as it appears.
    // When we click the trigger close to the bottom, that click's mouseup will
    // register on the menu list that's still being animated, making the whole
    // click register at the app's root. This would count as an outside click,
    // so we need to prevent that.
    // This may be related to https://github.com/cibernox/ember-power-select/issues/1263
    if (this._clickStartedWithin) {
      this.set('_clickStartedWithin', false);
      return;
    }

    if (!isDestroyed(this)) {
      this.set('_clickStartedWithin', false);
      let rootElement = this.element;
      let isComponent = rootElement === event.target;
      let inComponent = elementContainsTarget(rootElement, event.target);

      let inWormhole = isEventTargetInWormhole(event);

      if (isComponent || inComponent || inWormhole) {
        return;
      }

      this._onApply();
    }
  }

  @computed('environment.enabledActions')
  get _actionTypes() {
    let actionTypes = ACTION_TYPES.slice();

    forEachSegmentable((action, info) => {
      if (this.environment.enabledAction(action)) {
        actionTypes.push({
          label: info.name,
          value: action,
          icon: info.icon,
        });
      }
    });

    return actionTypes;
  }

  @computed('condition.condition.errors')
  get errors() {
    return Object.values(this.condition?.condition?.errors || {}).flat();
  }

  @action
  _onApply() {
    let { condition } = this.condition;
    let serializedCondition = {
      ...serializeFilter(condition, condition.type === 'email'),
      type: 'message',
    };

    return this.onApply(serializedCondition);
  }

  @action
  _setCondition(condition) {
    this.set('condition.condition', condition);
  }
}
